import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
//fontsource roboto font
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { trpc, trpcClient } from './lib/trpc';
import AppRouter from './Router';

const queryClient = new QueryClient();

const AppWithProviders = () => {
  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <App>
          <AppRouter />
        </App>
      </QueryClientProvider>
    </trpc.Provider>
  );
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppWithProviders />
  </StrictMode>
);
